(function ($) {
    /*
    * Main listbox method accepting an object of options.
    */
    $.fn.originListBox = function (options) {
        options = $.extend({
            sorting: 'auto', 		// auto, user (click & move), none @see filterElements()
            sortType: 'alpha', 	// Optionally can be a function passed in @see sortItems()
            sortBy: 'label', 	// label, description, order  @see sortItems()
            remove: false, 			// Add a remove link to the item 

            autoInit: true, 		// Autoload values from dataUrl? 
            dataUrl: null, 			// Provides a list of items to ajax into this component
            formatData: null, 	// Callback for transforming JSON returned from the server
            postData: null, 		// Provides data for getting to this components
            selected: null, 		// Array of values to select
            dataType: 'json',   // Default Ajax response type, can be json, html, etc.

            selectable: true, 		// Are the items able to be selected
            multiSelect: true, 	// Are multiple items able to be selected
            maxSelection: -1, 	// Is there a max number of items available for select
            unique: true, 		// Only allow unique values for list items (multiple items with the same value will be filtered)

            format: null, 			// Format a single item or pass back an arry of HTML for each item
            formatType: 'item', 	// "item" or "list" (how the format callback will be called; per item or once for all items)

            filterInput: null, 		// DOM Selector for an input element to attach key events to. @see originListBoxSetupFilter()
            filterCaseSensitive: false, // 
            filterField: 'label', 	// The field to filter on label or description
            filterComparison: 'startsWith', // 'contains', 'exact', 'startsWith', 'endsWith'

            callback: null          // Function to call after adding items to the listbox
        },
		options,
		{
		    // Private option ( not overrideable )
		    sortable: false
		});
        // Initialize each DOM element selected as a listbox
        return this.each(function () {
            $(this).addClass('originListBox');

            // Append an unordered list if one does not exist
            if ($('> ul', this).length == 0) {
                $(this).append('<ul></ul>');
            }

            options.multiSelect = options.multiSelect && (options.maxSelection == -1 || options.maxSelection > 1);
            $(this).data('options', options);

            // Bind a remove item event handler
            if (options.remove) {
                // Bind a click event (via event delegation) that measures where the 
                // click occurred within the LI. If it is on the far right portion of 
                // the LI, remove the element.
                $(this)
					.find('> ul').addClass('remove').end()
					.bind('click', function (evt) {
					    if ($(evt.target).is('li')) {
					        var offset = $(evt.target).offset();
					        var width = $(evt.target).width();
					        if ((offset.left + width - 38) < evt.pageX) {
					            $(evt.target).originListBoxRemove();
					        }
					    }
					});
            }

            if (options.filterInput !== null) {
                // Setup the input box (specified by the filterInput DOM selector) with key bindings
                // to filter the list upon user input.
                $(options.filterInput).originListBoxSetupFilter(this);
            }

            // Make list selectable
            if (options.selectable === true) {
                $(this).originListBoxSelectable(true, options.multiSelect);
            }

            // Make list sortable by allowing user to click & drag
            if (options.sorting == 'user') {
                $(this).originListBoxUserSortable(true);
            }

            // Load in the options if a url exists
            if (options.dataUrl && options.autoInit !== false) {
                $(this).originListBoxLoad(options.dataUrl, options.postData || {}, function () {
                    if (options.selected !== null) {
                        $(this).originListBoxSelect(options.selected);
                    }
                }, options.formatData);
            }
        });
    };

    /*
    * Given a URL, execute an Ajax request (expecting JSON in return) to load the data into the list.
    * Elements returned from the Ajax request are appendeded to the list. Expected data format to JSON
    * response is:
    * { value: '', label: '', description: '', order: '' }
    * If the format being returned from the server is different, the developer may implement the formatData 
    * callback in the listbox options (or specify it as the 4th argument). The formatData callback is passed 
    * the JSON returned from the server and is expected to return an array of objects with at least the 
    * format specified above.
    */
    $.fn.originListBoxLoad = function (url, post, callback, formatData) {
        var options = $(this).closest('.originListBox').data('options');
        var data = {};

        if (arguments.length == 1 && typeof arguments[0] == 'object') {
            data = $.extend(options, arguments[0]);
        } else {
            data = $.extend(options, { url: url, post: post, callback: callback, formatData: formatData });
        }

        if (!$.isFunction(formatData)) {
            formatData = options.formatData;
        }
        return this.each(function () {
            if ($.isFunction(data.post)) {
                data.callback = data.post;
                data.post = '';
            }

            var _this = this;
            $.ajax({
                url: data.url,
                data: data.post || {},
                type: 'POST',
                dataType: data.dataType,
                error: function (request, status, error) {
                    log(error);
                },
                success: function (response) {
                    if ($.isFunction(data.formatData)) {
                        // Allow the developer to make any data transformations
                        response.data = data.formatData(response.data);
                    }
                    
                    if (response.data && response.data.length == 0) {
                        $('#modalInstructionsText').hide();
                        $('#modalInstructionsTextNoData').show();
                    }

                    switch (data.dataType) {
                        case 'html':
                            if (data.filterInput != null) {
                                $(data.filterInput).val('');
                            }
                            $(_this)[0].innerHTML = response;
                            if ($.isFunction(data.callback)) {
                                data.callback.call(_this);
                            }
                            break;
                        default:
                            // For all other cases like 'json'
                            $(_this).originListBoxBulkAdd(response.data, function (i, finished) {
                                if (finished) {
                                    if ($.isFunction(data.callback)) {
                                        data.callback.call(_this);
                                    }
                                }
                            });
                            break;
                    }
                }
            });
        });
    };

    /*
    * Adds one or more elements to the list box. Multiple elements may be 
    * added by passing in an array of objects containing the keys: label, value,
    * description and order as argument 1. Additionally a single item may be 
    * added by passing in 4 arguments. @see originListBoxBulkAdd()
    */
    $.fn.originListBoxAdd = function (label, value, description, order) {
        if (arguments.length == 0 || !arguments[0]) {
            // No elements were passed in, simply return
            // This is needed as some server responses return an empty response
            return this;
        } else if (typeof arguments[0] == 'object') {
            // We have been handed an array of objects to add
            var options = $(this).data('options');
            var newItems = arguments[0];
            if (newItems.length == 0) {
                return this;
            }

            var itemCount = $('> ul > li', this).length;
            // Disable resorting all of the items if there are more than 75 in the list
            if (options.sorting == 'auto' && itemCount < 75) {
                var current = $(this).originListBoxItemData();
                var all = $.merge(current, newItems);
                all = sortItems(all, options.sortBy, options.sortType);
                $('> ul', this)
					.empty()
					.append(getHtmlForListItems(all, options));
                newItems = filterElementsByValues.call(this, newItems);
            } else {
                // Just append our items to the end of the list options
                newItems = $(getHtmlForListItems(newItems, options));
                $('> ul', this).append(newItems);
            }

            // Now that our list has been updated, go through and strip out any 
            // duplicate values
            if (options.unique) {
                // Did the user implement a callback?
                var items = $(this).find('> ul > li');
                var hash = {}, exclude = [];
                items.each(function () {
                    var val = $(this).dataset('value');
                    if (!hash[val]) {
                        hash[val] = true;
                    } else {
                        $(this).remove();
                        exclude.push(this);
                    }
                });
                exclude = $(exclude);
                newItems = $(newItems).filter(function () {
                    return exclude.index(this) == -1;
                });
            }

            $(this).trigger('listboxadded', [newItems.originListBoxItemData(), newItems.get()]);
            // Select the DOM elements we just created & added
            if (arguments[1] === true) {
                // Push stack
                return this.pushStack(items);
            }
            return this;
        } else {
            return this.originListBoxAdd({ label: label, value: value, description: description, order: order });
        }
    };

    /*
    * Bulk adds a large list of items to the listbox in a non-blocking fashion.
    * This method chunks the elements into 300 item blocks and executes it using
    * setTimeout.
    */
    $.fn.originListBoxBulkAdd = function (items, callback) {
        var options = $(this).data('options');
        var ilen = items.length;
        if (ilen > 100) {
            var _this = this;
            var html = '';
            var i = 0;
            var $ul = $('> ul', _this);

            if (!$.isFunction(callback)) {
                callback = function () { };
            }
            (function eat(list, size) {
                var data = list.slice(0, size);
                html += getHtmlForListItems(data, options);

                if (list.length > size) {
                    setTimeout(function () {
                        eat(list.slice(size), size);
                        // Trigger our callback (second param is "finished")
                        callback.call(_this, i, false);
                        i++;
                    }, 75);
                } else {
                    // Updating innerHTML directly is much quicker than using jQuery append.
                    $ul[0].innerHTML += html;
                    // We're done, trigger the callback			
                    callback.call(_this, i, true);
                    $(_this).trigger('listboxadded', []);
                }
            })(items, 300);
            return this;
        } else {
            var ret = this.originListBoxAdd(items);
            if ($.isFunction(callback)) {
                callback.call(this, 0, true);
            }
            return ret;
        }
    };

    /*
    * Given an array of objects, returns a single string of HTML generated from those objects.
    * This method may be overridden for alternate implementations by setting the options.format 
    * callback function.
    */
    function getHtmlForListItems(items, options) {
        var html = [], itemHtml = [], il = items.length;
        if ($.isFunction(options.format)) {
            if (options.formatType == 'list') {
                itemHtml = options.format(items);
            } else {
                for (var i = 0; i < il; i++) {
                    itemHtml.push(options.format(items[i]));
                }
            }
        } else {
            for (var i = 0; i < il; i++) {
                var data = $.extend({ value: '', order: '' }, items[i]);
                var content = '<span class="label">' + items[i].label + '</span>' + '<span class="description">' + (items[i].description || '') + '</span>';

                delete data.label;
                delete data.description;

                var attrs = '';
                for (var k in data) {
                    attrs += ' ' + $.dataset.encodeAttr(k) + '="' + data[k] + '"';
                }
                var selected = items[i].selected === true ? ' class="selected"' : '';
                var title = items[i].title ? ' title="' + items[i].title + '"' : '';

                var liItem = '<li' + selected + title + attrs + '>' + content + '</li>';
                itemHtml.push(liItem);
            }

            return itemHtml.join('');
        }

        // Use a native loop for IE
        for (var i = 0; i < il; i++) {
            var data = $.extend({ value: '', order: '' }, items[i]);
            delete data.label;
            delete data.description;
            var attrs = '';
            for (var k in data) {
                attrs += ' ' + $.dataset.encodeAttr(k) + '="' + data[k] + '"';
            }
            html.push('<li' + (items[i].selected === true ? ' class="selected"' : '') + (items[i].title ? ' title="' + items[i].title + '"' : '') + attrs + '>');
            html.push(itemHtml[i]);
            html.push('</li>');
        }
        return html.join('');
    }

    /*
    * Given a list of items, this method will an alphabetical or numerical sort on those items
    * and return an array of the new items. Optionally the sort algorithm may be overriden by 
    * defining options.sortType as a callback function returning -1, 0 or 1.
    */
    function sortItems(items, key, type) {
        if ($.isFunction(type)) {
            items.sort(type);
        } else if (type == 'numeric') {
            items.sort(function (a, b) {
                var ta = ('' + a[key]).replace(/[^0-9\.-]/g, '').match(/-?[0-9]+(\.\d+)?/);
                var tb = ('' + b[key]).replace(/[^0-9\.-]/g, '').match(/-?[0-9]+(\.\d+)?/);
                var aa = parseFloat(ta[0], 10),
					bb = parseFloat(tb[0], 10);
                return (aa > bb ? 1 :
							aa == bb ? 0 :
								-1);
            });
        } else {
            items.sort(function (a, b) {
                var aa = a[key].toUpperCase(),
					bb = b[key].toUpperCase();
                return (aa > bb ? 1 :
							aa == bb ? 0 :
								-1);
            });
        }
        return items;
    }

    /*
    * This method will take a field and value and return an array of DOM elements in the 
    * listbox matching those conditions. Additionally the case sensativity and comparison 
    * type (startsWith, endsWith, etc) may be specified. 
    */
    function filterElements(field, value, caseSensitive, comparison, includeDisabled) {
        if ($(this).is('div.originListBox')) {
            // If the listbox is "availabletitle", change the comparison to "contains" (PBI #33416)
            if ($(this)[0].id == 'availabletitle')
                comparison = 'contains';
            var elements = $('> ul > li', this);
            if (value !== undefined) {
                // Tokenize our string (this contains all values we're search for so we can do an indexOf)
                if (comparison == 'exact') {
                    value = '-#_#-' + value + '-#_#-';
                } else if (comparison == 'startsWith') {
                    value = '-#_#-' + value;
                } else if (comparison == 'endsWith') {
                    value = value + '-#_#-';
                }
                // else value 'contains'
                if (caseSensitive === false) {
                    value = value.toLowerCase();
                }

                // Unpacked this loop to a native one since IE really hates looping 
                // over large lists
                var elements = $(elements);
                if (includeDisabled === false) {
                    elements = elements.not('.elementDisabled');
                }

                var _values = [];
                // Determine which field we're searching (dataset attribute or html tag)
                if (elements.eq(0).dataset(field) != undefined) {
                    elements.each(function () {
                        _values.push([this, $(this).dataset(field)]);
                    });
                } else {
                    elements.children('span.' + field).each(function () {
                        _values.push([this, this.innerHTML]);
                    });
                }

                var il = _values.length;
                var tmp = [];

                for (var i = 0; i < il; i++) {
                    var txt = _values[i][1];
                    if (caseSensitive === false) {
                        txt = txt.toLowerCase();
                    }
                    if (('-#_#-' + txt + '-#_#-').indexOf(value) > -1) {
                        tmp.push($(_values[i][0]).closest('li')[0]);
                    }
                }

                elements = $(tmp);
            }
        } else {
            var elements = $(this).closest('li');
        }
        return elements;
    }

    /*
    * This method returns a list of listbox DOM elements matched given an array of values. An 
    * optional flag is provided to force the elements to be returned in the order of the array 
    * of values passed in.
    */
    function filterElementsByValues(values, preserveOrder) {
        if ($(this).is('div.originListBox')) {
            var elements = $('> ul > li', this);
            if (values) {
                // Is the values arg an object? If so, look for the value key
                if (values && values[0] && typeof values[0] == 'object') {
                    for (var i = 0; i < values.length; i++) {
                        values[i] = values[i].value;
                    }
                }
                // Tokenize our string (this contains all values we're search for so we can do an indexOf)
                var valuesString = '-#_#-' + values.join('-#_#-') + '-#_#-';

                // Unpacked this loop to a native one since IE really hates looping 
                // over large lists
                var il = elements.length;
                var tmp = [];
                var ordered = [];
                for (var i = 0; i < il; i++) {
                    var txt = $(elements[i]).dataset('value');
                    if (valuesString.indexOf('-#_#-' + txt + '-#_#-') > -1) {
                        tmp.push($(elements[i])[0]);
                        ordered[tmp.length - 1] = txt;
                    }
                }
                elements = $(tmp);

                // We need to re-order or filtered values to match the order of values passed in
                if (preserveOrder) {
                    var sorted = [];
                    for (var i = 0; i < values.length; i++) {
                        for (var j = 0; j < ordered.length; j++) {
                            if (values[i] == ordered[j]) {
                                sorted.push(elements[j]);
                                break;
                            }
                        }
                    }
                    elements = $(sorted);
                }
            }
        } else {
            var elements = $(this).closest('li');
        }
        return elements;
    }

    /*
    This method is used to the visible elements in a origin listbox.
    */
    function getListBoxElements() {
        var elements = [];
        if ($(this).is('div.originListBox')) {
            // using loop to get the visible li elements. Because li:visible && li:not(:hidden) returns 0.
            // li:visible returns 0 because display value for li elements is 'listitem'.
            // And li:not(:hidden) returns 0 because the li elements are hidden.
            $('> ul > li', this).each(function () {
                if ($(this).css('display') != 'none')
                    elements.push($(this));
            });
        }

        return elements;
    }

    /*
    * This plugin method takes a key value (as specified in the list items data, so for example 
    * label, description, value and order are all valid as well as any additional attributes added 
    * to elements). This function will then re-sort the listbox DOM elements.
    */
    $.fn.originListBoxSort = function (key) {
        return this.each(function () {
            var options = $(this).data('options');
            if (!key) {
                key = options.sortBy;
            }

            var items = $(this).originListBoxItemData();
            items = sortItems(items, key, options.sortType);

            // Empty and rebuild our list
            elements = $('> ul', this)
							.empty()
							.append(getHtmlForListItems(items, options.remove))
							.find('> li');

            // Trigger a sorted event
            $(this).trigger('listboxsorted', [elements.originListBoxItemData(), elements.get()]);
        });
    };

    /*
    * Sets the specified listbox DOM elements to enabled or disabled.
    */
    $.fn.originListBoxEnableElements = function (enabled) {
        return this.filter('li').toggleClass('elementDisabled', !enabled).toggle(enabled).end();
    };

    /*
    * This method given a set of arguments, will filter (select & hide non-matching) listbox DOM 
    * elements. You can 'unfilter' (show all elements) by passing in an empty string to the 
    * value argument.
    */
    $.fn.originListBoxFilter = function (field, value, comparison) {
        // Get our options
        var options = $(this).data('options');
        if (arguments.length == 1) {
            value = arguments[0];
            field = options.filterField;
            comparison = options.filterComparison;
        } else if (arguments.length == 2) {
            comparison = arguments[1];
            value = arguments[0];
            field = options.filterField;
        }

        // Get all of our elements
        var elements = filterElements.call(this);

        if (value == '') {
            selected = elements.not('.elementDisabled');
            selected.css({ 'display': 'block' });
        } else {
            var selected = filterElements.call(this, field, value, options.filterCaseSensitive, comparison, false);

            elements.not(selected).css({ 'display': 'none' });
            selected.css({ 'display': 'block' });
        }

        return this;
    };

    /*
    * This method expects an INPUT element to operate on. It then binds the appropriate 
    * events (such as keyup/keydown) to filter the associated listbox (as specified in argument 1)
    * @see originListBoxFilter() for filtering implementation.
    */
    $.fn.originListBoxSetupFilter = function (listboxToFilter) {
        return this.each(function () {
            $(this).bind('keydown keyup', function (evt) {
                evt.stopPropagation();
                evt.stopImmediatePropagation();

                if (evt.which == 13) {
                    evt.preventDefault();
                    return false;
                }

                if (evt.type == 'keyup') {
                    evt.preventDefault();
                    originTimer.start(function () { $(listboxToFilter).originListBoxFilter($(evt.target).val()); });
                }
            })
			.bind('focus blur', function (evt) {
			    var val = $(this).val();
			    if (evt.type == 'focus' && val == $(this).attr('defaultValue')) {
			        $(this).val('');
			    } else if (evt.type == 'blur' && val == '') {
			        $(this).val($(this).attr('defaultValue'));
			    }
			});
        });
    };

    /*
    * This is a utility method that given a field, value and comparison will return 
    * a new jQuery collection containing listbox DOM elements that matched those conditions.
    */
    $.fn.originListBoxSelectElements = function (field, value, comparison) {
        // Get our options
        var options = $(this).data('options');
        if (arguments.length == 1) {
            value = arguments[0];
            field = options.filterField;
            comparison = options.filterComparison;
        } else if (arguments.length == 2) {
            comparison = arguments[1];
            value = arguments[0];
            field = options.filterField;
        }
        var selected;
        if (value == '') {
            selected = filterElements.call(this);
        } else {
            selected = filterElements.call(this, field, value, options.filterCaseSensitive, comparison, true);
        }
        return this.pushStack(selected);
    };

    /*
    * This method will take listbox DOM elements and return an array of objects containing
    * the meta-data extracted from each DOM element. This method is called in multiple places 
    * such as when removing an element from one listbox and adding it to a second.
    */
    $.fn.originListBoxItemData = function (extended) {
        if ($(this).is('div.originListBox')) {
            elements = getListBoxElements.call(this);
        } else {
            elements = $(this); //.closest('li'); for some reason jquery resorts the LIs with the closest method.
        }
        var options = $(this).closest('div.originListBox').data('options');
        var items = [];
        for (var i = 0, il = elements.length; i < il; i++) {
            var dataset = $(elements[i]).dataset();
            if (dataset.value && dataset.value.length > 0) {
                var item = $.extend({
                    label: $.trim($('span.label', elements[i]).text()),
                    value: '',
                    description: $.trim($('span.description', elements[i]).text()),
                    order: ''
                }, dataset);
                if (extended === true) {
                    item.selected = $(elements[i]).hasClass('selected');
                    item.element = elements[i];
                }
                items.push(item);
            }
        }
        return items;
    };

    /*
    * This method returns the number of visible elements in the listbox.
    */
    $.fn.originListBoxSize = function () {
        var elements = getListBoxElements.call(this);

        if (elements.length > 0)
            return elements.length;

        return -1;
    };

    /*
    * This method returns an array of values from the listbox DOM elements.
    */
    $.fn.originListBoxValues = function () {
        if ($(this).is('div.originListBox')) {
            elements = $('> ul > li', this);
        } else {
            elements = $(this).closest('li');
        }
        var values = [];
        for (var i = 0, il = elements.length; i < il; i++) {
            values.push($(elements[i]).dataset('value'));
        }
        return values;
    };

    /*
    * This method selects all of the listbox DOM elements
    */
    $.fn.originListBoxItems = function () {
        return this.pushStack($('> ul > li', this));
    };

    /*
    * This method returns an array of objects from the currently selected listbox DOM elements.
    */
    $.fn.originListBoxSelected = function (extended) {
        return $('> ul > li.selected:visible', this).originListBoxItemData(extended || false);
    };

    /*
    * This method removes all listbox DOM elements quickly by clearing innerHTML.
    */
    $.fn.originListBoxEmptyInstantly = function () {
        return $(this).each(function () {
            // Faster way of removing elements from DOM.
            $(this).children('ul')[0].innerHTML = '';
        });
    };

    /*
    * This method removes all listbox DOM elements.
    */
    $.fn.originListBoxEmpty = function (triggerEvent) {
        var elements = filterElementsByValues.call(this);
        var div = $(this).closest('div.originListBox').eq(0);
        $('> ul', div).empty();
        if (triggerEvent !== false && elements.length > 0) {
            div.trigger('listboxemptied', [elements.originListBoxItemData(), elements.get()]);
        }
        return this;
    };

    /* 
    * This method selects the listbox DOM elements matched by the values array and removes them 
    * from the DOM. It then optionally triggers (by default) the listboxremoved event passing 
    * in the array of elements removed.
    */
    $.fn.originListBoxRemove = function (values, triggerEvent, preserveOrder) {
        var elements = filterElementsByValues.call(this, values, preserveOrder !== false);
        
        var div = $(this).closest('div.originListBox').eq(0);

        for (var i = 0; i < elements.length; i++) {
            if (elements[i].attributes['data-search-suppressed'] == undefined) {
                //elements.remove(i);
                $(elements[i]).remove();
            } else if (elements[i].attributes['data-search-suppressed'] != undefined && elements[i].attributes['data-search-suppressed'].value != 'true') {
                //elements.remove(i);
                $(elements[i]).remove();
            }
        }
        
        if (triggerEvent !== false && elements.length > 0) {
            div.trigger('listboxremoved', [elements.originListBoxItemData(), elements.get()]);
        }

        return this;
    };

    /*
    * Given a list of values, make sure those values are unselected and trigger the listboxunselected event 
    * passing in the elements that were currently unselected.
    */
    $.fn.originListBoxUnselect = function (values, triggerEvent) {
        var elements = filterElementsByValues.call(this, values);
        var unselected = elements.filter('.selected');
        elements.removeClass('selected selection');
        if (triggerEvent !== false && unselected.length > 0) {
            $(this).closest('div.originListBox').eq(0)
				.trigger('listboxunselected', [unselected.originListBoxItemData(), unselected.get()]);
        }
        return this;
    };

    /*
    * Given an array of values, select all of the elements and trigger the listboxselected event
    * passing in the elements selected in the order they appeared in the values array (as passed in by 
    * the developer).
    */
    $.fn.originListBoxSelect = function (values, triggerEvent, preserveOrder) {
        var elements = filterElementsByValues.call(this, values, preserveOrder !== false);
        elements
			.removeClass('selection')
			.addClass('selected');
        if (triggerEvent !== false && elements.length > 0) {
            $(this).closest('div.originListBox').eq(0)
				.trigger('listboxselected', [elements.originListBoxItemData(), elements.get()]);
        }
        return this;
    };

    /*
    * Enable the sortable option for listboxes by the user.
    */
    $.fn.originListBoxUserSortable = function (enable) {
        return this.each(function () {
            var options = $(this).data('options');
            if (enable !== false) {
                options.sortable = true;
                $(this)
					.originListBoxSelectable(false)
					.find('> ul')
						.sortable({
						    axis: 'y',
						    tollerance: 'pointer',
						    cursor: 'crosshair',
						    start: function (evt, ui) {
						        $(ui.item).addClass('sortable');
						    },
						    stop: function (evt, ui) {
						        $(ui.item).removeClass('sortable');
						    },
						    update: function (evt, ui) {
						        var div = $(this).parents('div.originListBox');
						        var items = $('> ul > li:visible', div);
						        div.trigger('listboxsorted', [items.originListBoxItemData(), items.get()]);
						    }
						});
            } else {
                options.sortable = false;
                $(this)
					.originListBoxSelectable(options.selectable)
					.find('> ul')
						.sortable('destroy');
            }
            $(this).data('options', options);
        });
    };

    /*
    * Enable the listbox (passing in false, disables the entire listbox)
    */
    $.fn.originListBoxEnabled = function (enabled) {
        if (enabled !== true && enabled !== false) {
            return !$(this).hasClass('originListBoxDisabled');
        }

        return this.each(function () {
            var options = $(this).data('options');
            if (!$(this).hasClass('originListBoxDisabled') != enabled) {
                if (enabled === false) {
                    $(this).addClass('originListBoxDisabled');

                    // Make list selectable
                    if (options.selectable === true) {
                        $(this).originListBoxSelectable(false);
                    }

                    // Make list sortable by allowing user to click & drag
                    if (options.sorting == 'user') {
                        $(this).originListBoxUserSortable(false);
                    }
                } else {
                    $(this).removeClass('originListBoxDisabled');

                    // Make list selectable
                    if (options.selectable === true) {
                        $(this).originListBoxSelectable(true, options.multiSelect);
                    }

                    // Make list sortable by allowing user to click & drag
                    if (options.sorting == 'user') {
                        $(this).originListBoxUserSortable(true);
                    }
                }
            }
        });
    };

    /*
    * This function enables the 'selectable' behavior or click + drag to 
    * select a list of items
    */
    $.fn.originListBoxSelectable = function (enabled, multi) {
        return this.each(function () {
            if (multi === false || enabled === false) {
                $(this).unbind('.multiselect');
            }

            if (enabled === false) {
                $(this).unbind('.selectable');
            } else {
                $(this)
					.data('selection', null)
					.bind('selectstart.selectable', function () {
					    return false;
					});
                if (multi === false) {
                    $(this)
					.bind('click.selectable', function (evt) {
					    if ($(evt.target).is('a')) {
					        return;
					    }
					    var options = $(this).data('options');
					    $('li.selection', this).removeClass('selection');
					    var li = $(evt.target).closest('li');
					    if (li.parents('.originListBox').length == 1 && li.length > 0) {
					        var maxSelected = (options.maxSelection > -1 && $('> ul > li.selected:visible', this).length + 1 > options.maxSelection);
					        if (li.hasClass('selected') || !maxSelected) {
					            li.toggleClass('selected');
					            $(this).trigger(li.hasClass('selected') ? 'listboxselected' : 'listboxunselected', [li.originListBoxItemData(), li.get()]);
					        } else if (maxSelected) {
					            if (options.maxSelection == 1) {
					                li.siblings('.selected:visible').removeClass('selected');
					                li.addClass('selected');
					                $(this).trigger('listboxselected', [li.originListBoxItemData(), li.get()]);
					            } else {
					                alert('You have reached the max number of selections (' + options.maxSelection + ')');
					            }
					        }
					    }
					});
                }

                if (multi !== false) {
                    $(this)
						.bind('mousedown.multiselect', function (evt) {
						    if ($(evt.target).is('a') || this == evt.target) {
						        return;
						    }

						    var options = $(this).data('options');
						    var items = $('> ul > li:visible', this);
						    var li = $(evt.target).closest('li');

						    // We detect a selection when the user keeps their mouse down and mouses out
						    // of this element box (sets selection to active) We only need this event once
						    $(this)
								.data('selection', {
								    items: items,
								    start: items.index(li[0]),
								    invert: li.hasClass('selected'),
								    max: options.maxSelection,
								    selected: $(li[0])
								})
								.addClass('mouseisdown');

						    // Unbind and rebind the event
						    $(document)
								.unbind('mouseup.listboxselectable')
								.connect('mouseup.listboxselectable', this, 'mouseupx');

						    $(evt.target).closest('li')
								.removeClass('hover')
								.addClass('selection');
						})
						.bind('mouseup.multiselect mouseupx.multiselect', function (evt, source) {
						    // Stopping propagation is critical since we're re-dispatching mouseup events from the document
						    evt.stopPropagation();
						    evt.stopImmediatePropagation();
						    // Do not prevent default or it will disable all clicks

						    $(this).removeClass('mouseisdown');
						    // Unbind our global mouseup listener
						    $(document).unbind('mouseup.listboxselectable');

						    var selection = $(this).data('selection');
						    if (selection !== null) {
						        $(this).data('selection', null);
						        evt.preventDefault();
						        // (Un)select the items collected
						        $(selection.selected)['originListBox' + (selection.invert ? 'Unselect' : 'Select')]();

						        // Prevent the click event from firing
						        return false;
						    }
						})
						.bind('mouseover.multiselect', function (evt) {
						    var selection = $(this).data('selection');
						    if (selection !== null) {
						        evt.stopPropagation();
						        evt.stopImmediatePropagation();

						        var selected = $('> ul > li.selected', this);
						        var union = selected.filter('.selection');
						        selected = selected.not('.selection');
						        var current = selection.items.index($(evt.target).closest('li'));

						        if (current > -1) {
						            var start = (selection.start < current ? selection.start : current);
						            var end = (selection.start < current ? current : selection.start);

						            // Limit our selection if a selection.max option has been set
						            var max = selection.max;
						            var total = (end - start) + selected.length - union.length;
						            if (max > -1 && (selected.length >= max || (end - start) >= max || total >= max)) {
						                // Add(Subtract) 1 from selection.max because the item we're currently over 
						                // is max + 1
						                if (selection.start == start) {
						                    end = selection.start + (max - selected.length) - 1;
						                } else {
						                    start = selection.start - (max - selected.length) + 1;
						                    end = selection.start;
						                }
						            }
						            selection.selected = selection.items.slice(start, (end + 1));

						            $(this).data('selection', selection);
						            selection.items.removeClass('selection');
						            selection.selected.addClass('selection');
						        }
						    }
						});
                }
            }
        });
    };

    /*
    * This method takes two list boxes and binds their events and behaviors together so that 
    * removing an item from one list box adds it to the second and vice versa. 
    */
    $.fn.originDualListBox = function (options, targetOptions) {
        return this.each(function () {
            var source = this;

            var sort = options.sorting && arguments.length == 1 ? options.sorting : (targetOptions && targetOptions.sorting || 'none');
            options = $.extend({
                remove: false,
                // 'remove' or 'select'
                listMode: 'select',
                filterInput: null,
                sorting: 'auto',
                formatData: null
            }, options || {}, {
                sorting: options.sorting && arguments.length == 2 ? options.sorting : 'auto'
            });

            $(source)
				.originListBox(options)
				.bind('listboxselected', function (evt, items, elements) {
				    log('dualistbox: source:listboxselected');
				    if (options.listMode == 'remove') {
				        $(elements).remove();
				    }
				    $(options.target).originListBoxAdd(items);
				})
				.bind('listboxunselected', function (evt, items, elements) {
				    log('dualistbox: source:listboxUNselected');
				    $(options.target).originListBoxRemove(items, false);
				})
				.bind('listboxadded', function () {
				    // We've added new elements to our source listbox (the availble choices)
				    // Grab the values from the selected box and select any in our source box 
				    // if they exist
				    $(this).originListBoxSelect($(options.target).originListBoxValues(), false);
				});

            targetOptions = $.extend({
                sorting: sort,
                remove: true, // Add a remove link
                selectable: true, // User is able to select
                dataUrl: null,
                postData: null,
                selected: null,
                sortBy: options.sortBy, 	// Set the sort options from the available listbox
                sortType: options.sortType,
                formatData: options.formatData
            }, targetOptions || {});

            $(options.target)
				.addClass('originListBoxSelected')
				.originListBox(targetOptions)
				.bind('listboxselected', function (evt, items, elements) {
				    log('dualistbox: target:listboxselected');
				    $(elements).originListBoxRemove();
				})
				.bind('listboxremoved', function (evt, items, elements) {
				    log('dualistbox: target:listboxremoved');
				    if (options.listMode == 'remove') {
				        $(source).originListBoxAdd(items, true);
				    } else if (options.listMode == 'select') {
				        $(source).originListBoxUnselect(items);
				    }
				});
        });
    };
})(jQuery);

(function (Origin) {
	/*
	* This is a utility method that wrapps originDualListBox() and also generates the additional HTML
	* markup including layout of the two listboxes.
	*/
	Origin.dualListBox = function (id, inOptions) {
		var element = $('#' + id);
		var data = element.dataset();
		var options = $.extend({
			autoInit: data.autoInit !== 'false',
			dataUrl: data.dataUrl || null,
			postData: data.postData || null,
			sorting: data.sorting || 'auto', 	// auto, user (click & move), none
			sortBy: data.sortBy || 'label',
			sortType: data.sortType || null,
			selected: (data.selected ? data.selected.split(/\s*,\s*/) : null),
			target: '#' + id,
			filterInput: (data.filter ? '#' + data.filter : null),
			sourceLabel: 'Available',
			targetLabel: 'Selected',
			dataType: data.dataType
		}, inOptions || {});
		data.target = id;
		var selectedOptions = {
			sorting: options.sorting,
			sortType: options.sortType,
			sortBy: options.sortBy
		};
		var filter = spacer = '';
		if (options.filterInput && $(options.filterInput).length == 0) {
			// We have an input filter to add
		    filter = '<input type="text" id="' + options.filterInput.replace(/[#]/g, '') + '" class="txt inputFilter ignoreInput watermark" data-watermark="Click to filter" data-auto="' + id + '-filter"/>';
			spacer = '<img src="/Themes/Default/Content/Images/transparent.gif" class="inputSpacer" />';
		}

		var template = '<div class="originDualListBox twoColumn clearfix"><div class="column"><label>{1}</label>'
					+ '{3}<div id="available{0}" {5} data-auto="available-{0}"></div></div><div class="column"><label>{2}</label>'
					+ '{4}<div id="{0}" {5} data-auto="selected-{0}"></div></div></div>';

		var classAttr = "";
		if (element.hasClass("emptyOnClearAll"))
			classAttr = 'class="emptyOnClearAll"';
		$('#' + id).after(Origin.formatString(template, id, options.sourceLabel, options.targetLabel, filter, spacer, classAttr)).remove();

		$('#' + id).dataset(data);

		return $('#available' + id)
					.originDualListBox(options, selectedOptions)
					.closest('.originDualListBox').dataset(data)[0];
	};
})(Origin);